export const areaConstants = {
  OUTLINE_REQUEST: 'AREAS_OUTLINE_REQUEST',
  OUTLINE_SUCCESS: 'AREAS_OUTLINE_SUCCESS',
  OUTLINE_FAILURE: 'AREAS_OUTLINE_FAILURE'
};